module.exports = __webpack_public_path__ + "static/img/flowIcon2.3dc95bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flowIcon2.png
// module id = GyPE
// module chunks = 1